module.exports = __webpack_public_path__ + "assets/img/77.a7ed5e30.png";